<template>
    <div class="detail-header">
        <div v-if="firstItem" class="detail-header__back">
            <BaseIcon icon="back" @click="goBack" id="test-button-back-to-dashboard" />
        </div>
        <div class="detail-header__info" v-bind:class="{'detail-header__info__margin':!firstItem}">
            <div class="detail-header__status" v-bind:style="{ backgroundColor: bColor }"></div>
            <div class="detail-header__title-wrapper">
                <div v-if="unit.name" class="detail-header__title" v-responsive.lg.xl.md.sm.xs>{{ nameFormatted }}</div>
                <div v-else class="detail-header__title placeholder">-place for name-</div>

                <div class="detail-header__subtitle bulk" v-if="this.bulk">
                    <div class="detail-header__subtitle__bulk">
                        <span v-responsive.xl.lg.md.sm>{{ $t('detail.format') }}: </span>
                        <div class="detail-header__subtitle__value">{{measurementFrame}}</div>
                    </div>
                    <div class="divider"></div>
                    <div class="detail-header__subtitle__bulk">
                        <span v-responsive.xl.lg.md.sm>{{ $t('detail.batch') }}: </span>
                        <div class="detail-header__subtitle__value">
                            <div class="detail-header__subtitle__value" v-if="Object.keys(unit.properties).length > 0">{{unit.properties.content}}-{{unit.properties.substrate}}-{{unit.properties.compression_factor}}</div>
                            <div class="detail-header__subtitle__value" v-if="Object.keys(unit.properties).length == 0">{{unit.batch.name}}</div>
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div class="detail-header__subtitle__bulk">
                        <span v-responsive.xl.lg.md.sm>{{ $t('dashboard.nav.type') }}: </span>
                        <div class="detail-header__subtitle__value">{{unit.typeName}}</div>
                    </div>
                    <div class="divider"></div>
                    <div class="detail-header__subtitle__bulk">
                        <span v-responsive.xl.lg.md.sm>{{ $t('dashboard.nav.remark') }}: </span>
                        <div class="detail-header__subtitle__value">{{unit.remark ? compLocation : ''}}</div>
                    </div>
                </div>

                <div class="detail-header__subtitle" v-if="!this.bulk">
                    <span v-responsive.xl.lg.md.sm>{{ $t('dashboard.nav.type') }}: </span>
                    <div class="detail-header__subtitle__value">{{unit.typeName}}</div>
                    <div class="divider"></div>
                    <span v-responsive.xl.lg.md.sm>{{ $t('dashboard.nav.remark') }}: </span>
                    <div class="detail-header__subtitle__value">{{unit.remark ? compLocation : ''}}</div>
                    <div v-if="configItem" class="detail-header__edit" v-click-outside="hideEditForm">
                        <BaseIcon icon="edit" @click="toggleEditForm" class="test-detail-button-edit" />
                        <transition name="fadeUp">
                            <div v-if="showEditForm" class="detail-header__edit__form">
                                <div class="triangle"></div>
                                <BaseInput :label="$t('header.custom_name')" v-model="editName" />
                                <BaseInput ref="inputRemark" :label="$t('dashboard.nav.remark')" v-model="editRemark" />
                                <div class="detail-header__edit__form__clear-remark" @click="clearRemark">
                                    clear remark
                                </div>
                                <div class="flex">
                                    <BaseButton @click.native="save" style="margin-left: auto;">
                                        {{ $t('buttons.save') }}
                                    </BaseButton>
                                </div>
                            </div>
                        </transition>
                        <transition name="fadeUp">
                            <div v-if="this.showRemarkHistory" class="detail-header__edit__remark-history" v-click-outside="hideRemarkHistory">
                                <div class="triangle"></div>
                                <Timeline
                                        :timeline-items="this.history"
                                        :message-when-no-items="this.$t('dashboard.remark.history')"
                                        :unique-year="true"
                                        :unique-timeline="true"
                                        :color-dots="'#b2de4d'"
                                />
                            </div>
                        </transition>
                    </div>
                    <div class="divider" v-if="this.history.length && !this.bulk" ></div>
                    <a v-if="this.history.length && !this.bulk" class="historyLink" @click="toggleRemarkHistory">{{ $t('dashboard.remark.show_history') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
	import {mapGetters} from 'vuex';

	export default {
		name: 'DetailHeader',
		props: {
			unit: Object,
			color: String,
			firstItem: {
				type: Boolean,
				default: true,
			},
      bulk: Boolean,
			configItem: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				bColor: this.color,
				editName: this.unit.name,
				editRemark: this.unit.remark,
				showEditForm: false,
        showRemarkHistory: false,
			};
		},
		computed: {
            ...mapGetters('tentacle', ['nameFormat']),
            nameFormatted() {
                return this.nameFormat ? this.unit.name : this.unit.genericName;
            },
            measurementFrame() {
                return this.unit.payload.name;
            },
            compLocation() {
                return (this.unit.remark.length > 23) ? `${this.unit.remark.substring(0, 20)}...` : this.unit.remark;
            },
            history() {
                return this.unit.remarkHistory.map(function (history) {
                    let time = new Date(history.createdAt.date);
                    return {
                        from: new Date(history.createdAt.date),
                        title: ('<div class="time">' + time.toLocaleTimeString() + '</div>' + history.user),
                        description: history.remark,
                        showDayAndMonth: true,
                        color: '#b2de4d',
                    };
                });
            },
			...mapGetters('tentacle', ['type']),
		},
        methods: {
            updateTentacles(data) {
                this.$store.dispatch('tentacle/updateUnit', data).then((response) => {
                    if (response.status === 200) {
                        this.flash('Tentacles updated', 'success');
                        this.$store.dispatch('tentacle/setUnitByID', this.unit.id);
                    }
                });
            },
            toggleEditForm() {
                this.showEditForm = !this.showEditForm;
            },
            toggleRemarkHistory() {
                this.showRemarkHistory = !this.showRemarkHistory;
            },
            hideEditForm() {
                this.showEditForm = false;
            },
            hideRemarkHistory() {
                this.showRemarkHistory = false;
            },
            clearRemark() {
                this.editRemark = "";
                var remarkInputId = 'test-input-' + this.$t('dashboard.nav.remark').toLowerCase().replace(' ', '-');
                document.getElementById(remarkInputId).focus();
            },
            save() {
                this.updateTentacles([{id: this.unit.id, name: this.editName, remark: this.editRemark}]);
                this.hideEditForm();
            },
            goBack() {
                this.$router.push({name: 'dashboard', params: {lang: this.$i18n.locale.toLowerCase(), type: this.type.urlSlug}});
            }
        },
    };
</script>

<style lang="scss">
    .timeline {
        .year {
            font-size: 0.8em !important;
            color: #363b54 !important;
        }

        .date-item {
            font-size: 0.9em !important;
            color: #363b54 !important;
            line-height: 18px !important;
        }

        .title-item {
            font-size: 1.1em !important;
            padding: 0 !important;
            line-height: 18px !important;
        }

        .description-item {
            font-size: 1.2em !important;
            color: gray !important;
            margin-top: 5px !important;
        }

        .time {
            color: #363b54;
            letter-spacing: 2px;
            font-size: 1.3rem;
            margin-bottom: 2px;
        }
    }
</style>

<style lang="scss" scoped>
    .detail-header {
        min-height: 10rem;
        padding: 0.5rem 0;
        display: flex;
        align-items: stretch;

        .historyLink {
            cursor: pointer;
        }

        &__back {
            align-self: center;
            width: 8rem;
            display: flex;
            justify-content: center;
            cursor: pointer;

            svg {
                fill: $grey;
                transition: all 0.4s;
            }

            &:hover {
                .icon {
                    fill: $company-color;
                }
            }
        }

        &__info {
            display: flex;
            align-items: center;
            &__margin {
                margin-left: 8em;
            }
        }

        &__status {
            height: 1rem;
            width: 1rem;
            border-radius: 50%;
        }

        &__title-wrapper {
            margin: 0 2rem;

            .placeholder {
                color: rgba(172, 180, 197, 0.26)
            }
        }

        &__title {
            font-weight: 700;
            font-size: 2.2rem;
            color: $dark;
            word-wrap: break-word;
            @media only screen and (min-width: 1500px) {
                max-width: 25vw;
            }
        }

        &__subtitle {
            margin-top: 0.3rem;
            color: $grey;
            font-size: 1.4rem;
            line-height: 2.5rem;
            font-weight: 600;
            display: flex;

            span {
                font-weight: 400;
                margin-right: 0.25em;
            }

            .divider {
                align-self: stretch;
                width: 0.1rem;
                background-color: $divider-color;
                margin: 0 1rem;
            }

            &__value {
                font-weight: 500;
            }

            &__bulk {
                display: flex;
                flex-direction: row;
            }
        }

        .bulk {
            flex-direction: column;

            @media only screen and (min-width: 1100px) and (max-width: 1500px) {
                flex-direction: row;
            }
        }

        &__edit {
            cursor: pointer;
            position: relative;
            margin-left: 10px;

            &:hover {
                .icon {
                    fill: $company-color;
                }
            }

            .icon {
                width: 2rem;
                height: 2rem;
                fill: $grey;
                transition: all 0.4s;
            }

            .triangle {
                position: absolute;
                top: -1.2rem;
                left: 1rem;
                margin: 0 auto;
                width: 0;
                height: 0;
                border-left: 1rem solid transparent;
                border-right: 1rem solid transparent;
                border-bottom: 1.2rem solid $white;
                @media only screen and (max-width: 991px) {
                    left: 25rem;
                }
            }

            &__form {
                z-index: 3;
                top: 3.3rem;
                left: -1.5rem;
                position: absolute;
                display: block;
                padding: 1rem;
                width: 30rem;
                height: 25rem;
                background-color: $white;
                box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15),
                0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);
                @media only screen and (max-width: 991px) {
                    top: 4.5rem;
                    left: -25.5rem;
                }

                &__clear-remark {
                    margin-top: -15px;
                    margin-left: 4px;
                }
            }

            &__remark-history {
                z-index: 3;
                top: 3.3rem;
                left: 3rem;
                position: absolute;
                display: block;
                padding: 1rem 0;
                width: 45rem;
                max-height: 40rem;
                overflow: auto;
                background-color: $white;
                box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15),
                0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);
                @media only screen and (max-width: 991px) {
                    top: 4.5rem;
                    left: -30.5rem;
                }
            }
        }
    }
</style>
